import { useNavigate } from "react-router-dom";
import {  TextField, FormControl, InputLabel, Select, MenuItem, Button, Snackbar,AlertColor,FormHelperText, Breadcrumbs } from "@mui/material";
import SecondaryButton from "../../components/SecondaryButton";
import { DateField,LocalizationProvider  } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import {useSelector,useDispatch} from "react-redux";
import { Flag, Policy } from "../../objects/policy";
import React, { useState, useEffect } from "react";
import dayjs, { Dayjs } from 'dayjs';
import StatesDropDown from "../../components/StatesDropDown";
import { QuoteService } from "../../services/quoteservice";
import { LexisPrefillService } from "../../services/lexisprefillservice";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Alert from "@mui/material/Alert";
import InputMask from "react-input-mask";
import { addErrorMessage } from "./Quote";
import { Toast } from "../../components/alerts/toast";
import { DoorBack } from "@mui/icons-material";
import { RatingService } from "../../services/ratingservice";
import { SystemFlags } from "../../objects/systemFlags";
import { DebounceTextField } from "../../components/DebounceTextField";
import { MessageBroker } from "../../services/messageBrokerService";
import { logActivityAsync } from "../../objects/events/loadEvents";
import { LookupService } from "../../services/lookupservice";
import JsonService from "../../services/jsonService";
export class DetailsValidate {
    hasAddress: boolean = true;
    hasPOBox: boolean = false;
    hasCity: boolean = true;
    hasState: boolean = true;
    hasZip: boolean = true;
    hasDob: boolean = true;
    hasGender: boolean = true;
    hasMaritalStatus: boolean = true;
    // hasMobile: boolean = true;
    hasEmail: boolean = true;
    hasValidEmail: boolean = true;
    hasBadZip: boolean= false;

    addressError = "Address is Required";
    poBoxError = "Address cannot be a PO Box";
    cityError = "City is required";
    stateError = "State is required";
    zipError = "Zip is required";
    badZipError = "We had to hit the brakes. The zip code needs to be corrected.";
    dobError = "Date Of Birth is required";
    genderError = "Gender is required";
    maritalError = "Marital Status is required";
    validEmailError = "Please enter a valid email address";
    // mobileError = "Mobile Phone Number is required";
    // emailError = "Email Address is required";
}


function Details(){
    let quoteService = new QuoteService();
    let prefillService = new LexisPrefillService();
    let ratingService = new RatingService();
    let messageBroker = new MessageBroker();
    let lookupService = new LookupService();

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const policy = useSelector((state: any)=> state.policyReducer) as Policy;
    const systemFlags = useSelector((state:any)=>state.systemFlagsPolicyReducer) as SystemFlags;
    const rateCycle = useSelector((state:any)=>state.rateCycleReducer) as string;

    const [isPageLoad, setIsPageLoad] = useState(true);
    const [policyObject, setPolicyObject] = useState<Policy>();
    const [address, setAddress] = useState("");
    
    const [city, setCity] = useState("");
    const [policyState, setPolicyState] = useState("");
    const [zip, setZip] = useState("");
    const [dateOfBirth, setDateOfBirth] = useState<Dayjs | null>(null);
    const [gender, setGender] = useState("");
    const [maritalStatus, setMaritalStatus] = useState("");
    const [mobilPhoneNum, setMobilePhoneNum] = useState("");
    const [emailAddress, setEmailAddress] = useState("");

    const [open, setOpen] = React.useState(false);
    const [isOpenErrorAlert, setIsOpenErrorAlert] = React.useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    const [validationObject, setValidation] = useState<DetailsValidate>(new DetailsValidate());
    const[errors, setErrors] = useState<string[]>([]);
    const[isToastOpen, setIsToastOpen] = useState(false);
    const[toastSeverity, setToastSeverity] = useState<AlertColor>("success");

    const handleClose = () => {
        setOpen(false);
    };

    const handleErrorAlertClose = () => {
        setIsOpenErrorAlert(false);
    };

    useEffect(()=>{
        (async()=>{
            
            await logActivityAsync(policy?.policyNumber ?? "", {
                recordKey: policy?.policyNumber,
                transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                action: "add_activity",
                subject: "Navigation",
                message: "Insured has navigated to the details screen",
                isException:false,
                error: "",
                level:"INFO",
                isSent: false
            });
            
        })();
    }, []);

    useEffect(()=> {
       
        if(policy === undefined || policy == null){
            navigate("/" + window.location.search);
        }


        if(isPageLoad){
            window.scrollTo(0, 0);
            var mailingAddress = policy?.addresses?.filter((e)=>{
                return e.type === "mailing"
            })[0];

            var mobilePhone = policy?.phoneNumbers?.filter((e)=>{
                return e.type === "Mobile"
            })[0];

            var insuredDriver = policy?.drivers?.filter((e)=>{
                return e.relation === "INSURED"
            })[0];
    
            setPolicyState(mailingAddress?.state ?? "");

            setAddress(mailingAddress?.streetName ?? "");

            if(insuredDriver?.dob !== undefined){
                setDateOfBirth(dayjs(insuredDriver?.dob));
            }
            
            setGender(insuredDriver?.gender);
            setMaritalStatus(insuredDriver?.isMarried ? "M" : "S");

            setEmailAddress(policy?.emailAddress);
            setMobilePhoneNum(mobilePhone?.number ?? "");

            setCity(mailingAddress?.city ?? "");
            setZip(mailingAddress?.zip ?? "");
    
            setPolicyObject(policy);
            setIsPageLoad(false);
        }
        
    }, [policy, rateCycle]);
    
    function NavigateBack(){
        navigate("/" + window.location.search, {state: {data: policyObject, hasData: true}});
    }

    async function NavigateForward() {
       var isValid = await isFormValid();

        if(!isValid.isValid) {

            if(isValid.errors.length>0){
                setIsToastOpen(true);            
                setToastSeverity("error");

                await logActivityAsync(policy?.policyNumber ?? "", {
                    recordKey: policy?.policyNumber,
                    transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                    action: "add_activity",
                    subject: "Details Screen - Validate Form To Continue",
                    message: `Quote# ${policyObject?.policyNumber} - ${policyObject?.insuredFirstName} ${policyObject?.insuredLastName}, ${policyObject?.emailAddress ?? "NO EMAIL"}`,
                    isException: true,
                    error: "Attempt to continue failed, there are errors in form to be corrected",
                    level: "WARNING",
                    isSent: false
                });
            }

            return;
        }
       
        var newPolicy = quoteService.updateDetailInfo((policyObject ?? new Policy()), 
                                                                emailAddress, 
                                                                mobilPhoneNum, 
                                                                dateOfBirth, 
                                                                gender, 
                                                                maritalStatus, 
                                                                address, 
                                                                city, 
                                                                policyState, 
                                                                zip);
                               
            try {
                setOpen(true);

                console.log({systemFlags:systemFlags});
                //if(!systemFlags?.hasPrefill){
                    var prefillResponse = await prefillService.sendRequest(newPolicy.policyNumber, 
                        newPolicy.insuredFirstName, 
                        newPolicy.insuredLastName,
                        address,
                        city,
                        policyState,
                        zip,
                        newPolicy.effectiveDate);
    
                    if(!prefillResponse.ok) {
                        
                        await logActivityAsync(policy?.policyNumber ?? "", {
                            recordKey: policy?.policyNumber,
                            transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                            action: "error_activity",
                            subject: "Details Screen - Prefill Service",
                            message: `Quote# ${newPolicy?.policyNumber} - ${newPolicy?.insuredFirstName} ${newPolicy?.insuredLastName}, ${newPolicy?.emailAddress ?? "NO EMAIL"}`,
                            isException: true,
                            error: prefillResponse?.error?.message ?? "Empty Response",
                            level: "ERROR",
                            isSent: false
                        });

                        console.error(prefillResponse.error)
                        setErrorMessage("Error occurred requesting additional information from third party providers")
                        setOpen(false);
                        setIsOpenErrorAlert(true);
                        return;
                    }
    
                    var data = prefillResponse.data.prefillData;

                    console.log({lexis_prefill_data: data});
                        
                    var newDrivers = prefillService.toDriversArray(newPolicy.drivers, data.subjects);
                    var newVehicles = prefillService.toVehiclesArray(newPolicy.vehicles, data.cars, data.selectedCoverages);

                    var selectedPolicyCoverages = data.selectedCoverages.filter((m:any)=>m.level == "POLICY");

                    var newLimits = prefillService.toLimitsArray(newPolicy.limits, selectedPolicyCoverages);
    
                    var allVehicles = [...newPolicy.vehicles, ...newVehicles];
                    var allDrivers = [...newPolicy.drivers, ...newDrivers];
                    
                    newPolicy.hasPriorCoverage = data.hasPriorCoverage;
                    newPolicy.hasNoLapse = data.hasNoLapse;
                    newPolicy.has131Lapse = data.has131Lapse;
                    newPolicy.hasGtr31Lapse = data.hasGtr31Lapse;
                    newPolicy.previousExpirationDate = data.previousExpirationDate;
                    newPolicy.integrationId = prefillResponse.data.integrationId;
                    newPolicy.priorBiLimit = data.priorBILimit;
                    // "previousCompany": null,
                    // "priorMonthsInsured": null,
                    // "priorBILimit": null

                    newPolicy.vehicles = allVehicles;
                    newPolicy.drivers = allDrivers;
                    newPolicy.limits = newLimits;


                    var flagDescription = prefillResponse.data.isFromCache ? "CV pulled cache data from other quote(s)" : "Coverage Verifier has been ordered";

                    var cvFlag = new Flag();
                    cvFlag.name = "Completed Coverage Verifier";
                    cvFlag.value=flagDescription;
                    cvFlag.hasFlag = true;
                    cvFlag.indexNumber = 0;
                    cvFlag.attributes=[];

                    var hasFlag = newPolicy.flags.some(m=> m.name == "Completed Coverage Verifier");

                    if(!hasFlag){
                        newPolicy.flags.push(cvFlag);
                    }
                    
                //}

                var save = await quoteService.save(newPolicy);

                if(!save.ok){
                    
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Details Screen - Save Quote",
                        message: `Quote# ${newPolicy?.policyNumber} - ${newPolicy?.insuredFirstName} ${newPolicy?.insuredLastName}, ${newPolicy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: save?.error?.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });

                    setErrorMessage(save.error.message.join(", "))
                    setOpen(false);
                    setIsOpenErrorAlert(true);

                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/");            
                    navigate("/error?" + queryParams.toString());

                    return;
                }

                var savedPolicyNumber = save.data.policyNumber;
                
                var serialize = await quoteService.serialize(savedPolicyNumber);
                
                if(!serialize.ok){
                    await logActivityAsync(policy?.policyNumber ?? "", {
                        recordKey: policy?.policyNumber,
                        transactionDate: dayjs(new Date().toUTCString()).toISOString(),
                        action: "error_activity",
                        subject: "Details Screen - Serialize quote",
                        message: `Quote# ${newPolicy?.policyNumber} - ${newPolicy?.insuredFirstName} ${newPolicy?.insuredLastName}, ${newPolicy?.emailAddress ?? "NO EMAIL"}`,
                        isException: true,
                        error: serialize?.error.message ?? "Empty Response",
                        level: "ERROR",
                        isSent: false
                    });
                    
                    var queryParams = new URLSearchParams(window.location.search);
                    queryParams.set("returnUrl", "/");            
                    navigate("/error?" + queryParams.toString());
                    
                    return;
                }



                var savedPolicy = serialize.data as Policy;
                var clonePolicy = {...savedPolicy};
                clonePolicy.integrationId = savedPolicy.policyNumber;
                
                setPolicyObject(clonePolicy);
                
                var specificAddress = clonePolicy.addresses.find(m=>m.type == "mailing");

                dispatch({type: "ORDER_PREFILL", payload: systemFlags})
                dispatch({type: "UPDATE", payload: clonePolicy})
                navigate("/vehicles" + window.location.search, {state: {data: newPolicy, hasData: true }});
            } catch(err) {
                setOpen(false);
                setIsOpenErrorAlert(true);
            }
   
    }

    function onStatesChanged(e :any){
        setPolicyState(e.target.value)
        setValidation({...validationObject, hasState:(e.target.value !== "" ? true : false) });
        addErrorMessage(e.target.value === "", (e.target.value === "" ? validationObject.stateError : ""), errors, setErrors);
    }

    function isPoBox(address: string) : boolean{
        return (address.startsWith("PO") || address.startsWith("P.O.") || address.startsWith("P.O")  || address.startsWith("PO."))
    }

    async function isFormValid() {
        var isValid = true;
        var messages = [];
        var currentValidation = {...validationObject};

        if(address === "" || address === undefined || address === null || !validationObject.hasAddress){
            isValid = false;
            messages.push(validationObject.addressError);
            currentValidation = {...currentValidation, hasAddress:false }
        }

        if(isPoBox((address ?? "").toUpperCase())){
            isValid = false;
            messages.push(validationObject.poBoxError);
            currentValidation = {...currentValidation, hasPOBox:true }
        }

        if(city === "" || city === undefined || city === null || !validationObject.hasCity){
            isValid = false;
            messages.push(validationObject.cityError);
            currentValidation = {...currentValidation, hasCity:false }
        }

        if(policyState === "" || policyState === undefined || policyState === null || !validationObject.hasState){
            isValid = false;
            messages.push(validationObject.stateError);
            currentValidation = {...currentValidation, hasState:false }
        }
        
        if(zip === "" || zip === undefined || zip === null || !validationObject.hasZip){
            isValid = false;
            messages.push(validationObject.zipError);
            currentValidation = {...currentValidation, hasZip:false }
        }

        if(dateOfBirth === undefined || dateOfBirth === null || !dateOfBirth.isValid || !validationObject.hasDob){
            isValid = false;
            messages.push(validationObject.dobError);
            currentValidation = {...currentValidation, hasDob:false }
        }

        if(maritalStatus === "" || maritalStatus === undefined || maritalStatus === null || !validationObject.hasMaritalStatus){
            isValid = false;
            messages.push(validationObject.maritalError);
            currentValidation = {...currentValidation, hasMaritalStatus:false }
        }

        if(emailAddress !== "" && (emailAddress === undefined || emailAddress === null || !validateEmail(emailAddress))){
            isValid = false;
            messages.push(validationObject.validEmailError);
            currentValidation = {...currentValidation, hasEmail:false }
        }

        var zipResult = await lookupService.GetZipCode(policyState, zip);
        if(!zipResult.ok){
            isValid = false;
            currentValidation = {...currentValidation, hasBadZip:true }
        }else{
            currentValidation = {...currentValidation, hasBadZip:false }
        }
        
        setValidation({...currentValidation })
        setErrors(messages);

        return {isValid:isValid, errors:messages};
    }

    function validateEmail(emailAddress: string) {
        var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
        return emailAddress.match(mailformat) ? true : false;
    }

    return (
        <>
            <div className="w-100 ">
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw] pt-10">
                <Breadcrumbs>
                        <h3 className="text-2xl pb-5 mt-0">Step 2 of 7</h3>
                    </Breadcrumbs>
                    <div className="grid grid-cols-12 gap-5 gap-y-6 pb-9">                
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-4 lg:col-span-4 xl:col-span-4">                            
                            <TextField 
                                id="txtStreetAddress" 
                                name="StreetAddress" 
                                className="p-1 w-full" 
                                label="Street Address" 
                                variant="outlined"
                                value={address}
                                required
                                error={!validationObject.hasAddress || validationObject.hasPOBox}
                                helperText={!validationObject.hasAddress ? validationObject.addressError : validationObject.hasPOBox ? validationObject.poBoxError : ""}
                                onChange={(e)=>{ 
                                    var isPo:boolean = isPoBox((e.target.value ?? "").toUpperCase());
                                    
                                    setAddress(e.target.value) 
                                    setValidation({...validationObject, hasAddress:(e.target.value !== "" ? true : false), hasPOBox:isPo });
                                    addErrorMessage(e.target.value === "", validationObject.addressError, errors, setErrors);
                                    addErrorMessage(isPo, validationObject.poBoxError, errors, setErrors);
                                }} />

                        </div>  
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-3 lg:col-span-3 xl:col-span-3">
                            <TextField id="txtCity" 
                                name="City"
                                className="p-1 w-full"
                                label="City" 
                                variant="outlined"
                                value={city}
                                required={true}
                                error={!validationObject.hasCity}
                                helperText={!validationObject.hasCity ? validationObject.cityError : ""}
                                onChange={(e)=>{
                                    setCity(e.target.value)
                                    setValidation({...validationObject, hasCity:(e.target.value !== "" ? true : false) });
                                    addErrorMessage(e.target.value === "", validationObject.cityError, errors, setErrors);
                                }} />
                        </div>  
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-3 lg:col-span-2 xl:col-span-2">
                            <StatesDropDown 
                                name="State"
                                id="txtState"
                                className={""} 
                                updateSelectedState={onStatesChanged} 
                                defaultValue = {policyState}
                                value={policyState} 
                                hasError={!validationObject.hasState} />
                                <FormHelperText className={"Mui-error"} >{(!validationObject.hasState ? validationObject.stateError : "")}</FormHelperText>
                        </div>  
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-2 lg:col-span-3 xl:col-span-3">
                            <TextField 
                                id="txtZip" 
                                name="Zip" 
                                className="p-1 w-full" 
                                label="Zip" 
                                variant="outlined"
                                value={zip}
                                required={true}
                                error={!validationObject.hasZip || validationObject.hasBadZip}
                                helperText={!validationObject.hasZip ? validationObject.zipError : validationObject.hasBadZip ? validationObject.badZipError: ""}
                                onChange={async (e)=>{
                                    
                                    setZip(e.target.value);
                                    setValidation({...validationObject, hasZip:(e.target.value !== "" ? true : false) });
                                    
                                    addErrorMessage(e.target.value === "", (validationObject.hasBadZip ? validationObject.badZipError : validationObject.zipError), errors, setErrors);
                                }
                                } />
                        </div>  
                    </div>
                    <div className="grid grid-cols-12 gap-5 gap-y-6 pb-9">                
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-3">                            
                            <LocalizationProvider dateAdapter={AdapterDayjs}>
                                <DateField 
                                    label="Date Of Birth *" 
                                    value={dateOfBirth} 
                                    className="w-full"
                                    onChange={(e)=>{
                                        setDateOfBirth(e);
                                        setValidation({...validationObject, hasDob: e!== null && e!==undefined })
                                        addErrorMessage(!e?.isValid, validationObject.dobError, errors, setErrors);
                                    }}
                                    slotProps={{
                                        textField:{
                                            error: !validationObject.hasDob
                                        }
                                    }} />
                                <FormHelperText className={"Mui-error"} >{(!validationObject.hasDob ? validationObject.dobError : "")}</FormHelperText>

                            </LocalizationProvider>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-5 gap-y-6 pb-9">                
                        <div className="form-group  col-span-12 sm:col-span-12 md:col-span-4 lg:col-span-3 xl:col-span-3">
                            <FormControl fullWidth>
                                <InputLabel id="lbl-ddlMaritalStatus">Marital Status</InputLabel>
                                <Select
                                    id="ddlMaritalStatus"
                                    name="MaritalStatus"
                                    label="Marital Status"
                                    labelId="lbl-ddlMaritalStatus"
                                    value={maritalStatus}
                                    onChange={(e:any) => { setMaritalStatus(e.target.value) }}
                                    >
                                    <MenuItem value="S">Single</MenuItem>
                                    <MenuItem value="M">Married</MenuItem>
                                </Select>
                                <FormHelperText className={"Mui-error"} >{(!validationObject.hasMaritalStatus ? validationObject.maritalError : "")}</FormHelperText>
                            </FormControl>
                        </div>
                    </div>

                    <div className="grid grid-cols-12 gap-5 gap-y-6 pb-9">                
                        <div className="form-group col-span-12 sm:col-span-2 md:col-span-6 lg:col-span-4 xl:col-span-4">                            
                            <InputMask
                                mask="999-999-9999"
                                value={mobilPhoneNum}
                                disabled={false}
                                maskChar=" "
                                id="txtMobilePhoneNum"
                                name="MobilePhoneNum"                                                                
                                onChange={(e:any)=>{
                                    setMobilePhoneNum(e.target.value)
                                    // setValidation({...validationObject, hasMobile:(e.target.value !== "" ? true : false) });
                                    // addErrorMessage(e.target.value === "", validationObject.mobileError, errors, setErrors);
                                }}    
                                >
                               <TextField
                                label="Mobile Phone Number"
                                className="p-1 w-full" 
                                variant="outlined"
                                // error={!validationObject.hasMobile}
                                // helperText={!validationObject.hasMobile ? validationObject.mobileError : ""}
                                />
                            </InputMask>
                        </div>  
                        <div className="form-group col-span-12 sm:col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            <DebounceTextField 
                                id="txtEmailAddress"
                                name="EmailAddress"
                                label="Email Address"
                                value={emailAddress}
                                onTextFieldChange={(e:any)=>{
                                    setEmailAddress(e.target.value)
                                    
                                    var isValid = validateEmail(e.target.value) || e.target.value === "";
                                    setValidation({...validationObject, hasValidEmail: isValid });
                                    addErrorMessage(!isValid, validationObject.validEmailError, errors, setErrors);
                                }}
                                hasError={!validationObject.hasValidEmail}
                                helperText={!validationObject.hasValidEmail ? validationObject.validEmailError : ""}
                            />
                            <span className="text-sm italic">We do not sell your email address or other personal information, but we may follow up with you about your quote</span>
                        </div>  
                    </div>
                </div>
            </div>
            <div className="mb-5 p-5 bg-[#e0e1dd]">
                <div className="w-[90vw] m-auto sm:w-[90vw] md:w-[90vw] lg:w-[90vw] xl:w-[60vw]">
                    <SecondaryButton onClick={NavigateBack} variant="contained" className="p-2 w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6  ">Back</SecondaryButton>
                    <Button variant="contained"  className="btn-continue hover:cursor-pointer float-right p-3 mt-10 w-1/3 sm:w-1/3 md:w-1/6 lg:w-1/6 xl:w-1/6  " onClick={NavigateForward}>Continue</Button>
                    <div className="clear-both"></div>
                </div>
            </div>

            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
                onClick={handleClose}>
                <CircularProgress color="inherit" />
            </Backdrop>

            <Snackbar open={isOpenErrorAlert} 
            autoHideDuration={6000} 
            onClose={handleErrorAlertClose} 
            anchorOrigin={ { vertical:"top", horizontal:"right" }}>
                <Alert onClose={handleErrorAlertClose} severity="error" sx={{ width: '100%' }}>
                    {errorMessage}
                </Alert>
            </Snackbar>

            <Toast isOpen={isToastOpen} onClose={(e:any)=>{ setIsToastOpen(false); }} severity={toastSeverity} message={errors} />
        </>
    );
}

export default Details;